import merge from 'classnames';

import { ProgressSpinnerProps } from './types';

import styles from './ProgressSpinner.module.scss';

export const ProgressSpinner = (props: ProgressSpinnerProps) => {
  const { size = 40, unit = 'px', classes = {}, active = true } = props;
  const dimension = `${size}${unit}`;

  if (!active) return null;

  return (
    <div
      className={merge(classes.container, styles.container)}
      data-testid="progress-spinner-wrapper"
    >
      <div
        className={merge(classes.spinner, styles.spinner)}
        role="status"
        style={{ width: dimension, height: dimension }}
      >
        <span className={styles.sr_only}>Loading...</span>
      </div>
    </div>
  );
};
